import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { DataGrid, GridOverlay, } from '@mui/x-data-grid';
const columns = [
    { field: 'age', headerName: 'Age', minWidth: 70, disableColumnMenu: true },
    {
        field: 'gender',
        headerName: 'Gender',
        minWidth: 70,
        disableColumnMenu: true,
    },
    {
        field: 'interests',
        headerName: 'Interest Category',
        minWidth: 280,
        flex: 1,
        disableColumnMenu: true,
        renderCell: (params) => {
            const categories = params.value;
            const formattedText = categories.join(' and ');
            return (_jsx(Tooltip, { arrow: true, title: formattedText, placement: "top", slotProps: {
                    tooltip: {
                        sx: {
                            fontSize: '13px',
                            fontWeight: 400,
                            maxWidth: '450px',
                        },
                    },
                }, children: _jsx(Typography, { noWrap: true, marginTop: "6px", fontSize: "14px", fontWeight: 400, maxWidth: "100%", width: "fit-content", children: formattedText }) }));
        },
    },
    {
        field: 'intent',
        headerName: 'Intent Question',
        minWidth: 150,
        disableColumnMenu: true,
        renderCell: (params) => (_jsx(Typography, { marginTop: "6px", fontSize: "14px", fontWeight: 400, children: params.value ? 'Yes' : 'No' })),
    },
    {
        field: 'creativeRating',
        headerName: 'Rating',
        minWidth: 70,
        disableColumnMenu: true,
    },
    {
        field: 'reviewerInput',
        headerName: 'Reviewer Input',
        minWidth: 450,
        flex: 2,
        disableColumnMenu: true,
        renderCell: (params) => (_jsx(Tooltip, { arrow: true, title: params.value, placement: "top", slotProps: {
                tooltip: {
                    sx: {
                        fontSize: '13px',
                        fontWeight: 400,
                        maxWidth: '450px',
                    },
                },
            }, children: _jsx(Typography, { noWrap: true, marginTop: "6px", fontSize: "14px", fontWeight: 400, maxWidth: "100%", width: "fit-content", children: params.value }) })),
    },
];
export const SurveyTable = ({ data, loading, error }) => {
    const theme = useTheme();
    return (_jsx(Box, { display: "flex", marginTop: "15px", children: _jsx(DataGrid, { rows: data, columns: columns, loading: loading, rowHeight: 36, columnHeaderHeight: 36, hideFooter: true, hideFooterPagination: true, getRowId: () => crypto.randomUUID(), slots: {
                noRowsOverlay: () => (_jsx(GridOverlay, { children: error ? (_jsx(Typography, { color: "error", children: error })) : (_jsx(Typography, { children: "No data available." })) })),
            }, sx: {
                '--DataGrid-containerBackground': theme.palette.grey[200],
                '& .MuiDataGrid-columnHeaders': {
                    color: theme.palette.text.primary,
                    fontWeight: 500,
                    fontSize: '14px',
                },
                '& .MuiDataGrid-row': {
                    color: theme.palette.text.primary,
                    fontWeight: 400,
                    fontSize: '14px',
                },
                '& .MuiDataGrid-cell': {
                    borderBottom: `1px solid ${theme.palette.grey[200]}`,
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                },
            } }) }));
};
